module.exports = "<app-navbar></app-navbar>\n<app-login></app-login>\n<app-dashboard></app-dashboard>\n<app-call></app-call>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main